import { Observable } from "rxjs";

import st from "lib/utils/index";
import { CompanyRepository } from "lib/repositories/index";
import { createFormInstance } from "modules/utils/index";
import { fetchCurrentCompany } from "modules/auth";

export const INITIALIZE_VIEW = "settings/SaasSettingsView/INITIALIZE_VIEW";
export const INITIALIZE_MODEL = "settings/SaasSettingsView/INITIALIZE_MODEL";
export const UPDATE_MODEL = "settings/SaasSettingsView/UPDATE_MODEL";
export const VALIDATE = "settings/SaasSettingsView/VALIDATE";
export const SUBMIT = "settings/SaasSettingsView/SUBMIT";
export const FETCH_SUBMIT_START = "settings/SaasSettingsView/FETCH_SUBMIT_START";
export const FETCH_SUBMIT_SUCCESS = "settings/SaasSettingsView/FETCH_SUBMIT_SUCCESS";
export const FETCH_SUBMIT_FAILURE = "settings/SaasSettingsView/FETCH_SUBMIT_FAILURE";

export const stateSelector = (state) => state.settings.SaasSettingsView;

const formInstance = createFormInstance({
  INITIALIZE_MODEL,
  UPDATE_MODEL,
  VALIDATE,
  SUBMIT,
  FETCH_SUBMIT_START,
  FETCH_SUBMIT_SUCCESS,
  FETCH_SUBMIT_FAILURE,
  stateSelector,
  validate: ({ form: { model } }, errors) => {
    // errors.add(`model.name`, st.validators.presence(model.name))
  },
  submitModel: ({ form: { initialModel, model } }) => {
    const serialize = (company) => ({
      id: company.id,
      saas_cover_image: company.saas_cover_image,
      translations: company.translations.map((t) => ({
        id: t.id,
        locale: t.locale,
        saas_name: t.saas_name,
        saas_short_description: t.saas_short_description,
      })),
    });
    return CompanyRepository.update(serialize(model), serialize(initialModel), { useFormData: true });
  },
});

const initialState = {
  form: formInstance.initialState,
};

const reducers = {
  ...formInstance.reducersMap,

  [INITIALIZE_VIEW]: () => initialState,
};

const epics = [
  ...formInstance.epics,

  (actions$, { getState }) =>
    actions$.ofType(INITIALIZE_VIEW).map(() => {
      const company = getState().auth.company.model;
      return initializeModel(company);
    }),

  (actions$) => actions$.ofType(FETCH_SUBMIT_SUCCESS).mapTo(fetchCurrentCompany()),
];

export function initializeView() {
  return { type: INITIALIZE_VIEW };
}

export const { initializeModel, updateModel, validate, submit } = formInstance.actions;

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/settings/SaasSettingsView/index.js